import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class GlobalSearchService {

  searchResult$: BehaviorSubject<Object>;
  faqId$: BehaviorSubject<number>;

  constructor(private http: HttpClient, private snackBar: MatSnackBar) {
    this.searchResult$ = new BehaviorSubject(null);
    this.faqId$ = new BehaviorSubject(null);
  }

  searchData(value: string, countFlag: number) {
    this.searchResult$.next({ loading: true, data: [], count: countFlag });

    const params = new HttpParams().set('searchkey', value);

    this.http.get('/api/data/search', { params }).subscribe(
      (response: any) => {
        const rtn = response;
        this.searchResult$.next({ loading: false, data: rtn, count: countFlag });
      }, (error: any) => {
        const message = 'Unable to Search';
        const snackBarRef = this.snackBar.open(message, '', { duration: 2000, verticalPosition: 'top', horizontalPosition: 'right', panelClass: 'aip-error-toast' });
      }
    );
  }

  setFaqId(id: number) {
    this.faqId$.next(id);
  }
}
